import React, { useEffect, useContext, useRef } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "./pages/Provider";
import Auth from "./services/auth";
import { Admin } from "./pages/Admin";
import { StoreContext } from "./store/Store";
import { actionTypes } from "./store/storeTypes";

const authServ = new Auth();

const App = () => {
  const [store, dispatch] = useContext(StoreContext);
  const parentRef = useRef(null);

  useEffect(() => {  
    authServ.login("anonymous@d2legal.com", "P@ssword135");
    dispatch({ type: actionTypes.SET_AUTH, payload: authServ });
  }, [dispatch]);

 
  if (store) {
    //do nothing
  }

  return (
    <div
      ref={parentRef}
      style={{
        fontFamily: "Graphic",
        height: "100vh",
        width: "100vw",
        boxSizing: "border-box",
      }}
    >
      <Routes>
        <Route exact path="/" element={<Admin />} />
        <Route exact path="/flow" element={<Provider  mode="flow"/>} />
        <Route exact path="/layout" element={<Provider mode="layout"/>} />
      </Routes>
    </div>
  );
};
const RoutedApp = () => (
  <Router>
    <App></App>
  </Router>
);

export default RoutedApp;
